import { z } from "zod";

export const signInSchema = z.object({
  email: z.string().trim().email("Email inválido"),
  password: z.string().min(6, "Senha deve ter ao menos 6 caracteres"),
});

export const signUpSchema = signInSchema.extend({
  nome: z.string().trim().min(1, "Informe seu nome"),
  orgaoId: z.string().uuid("Selecione um órgão"),
  role: z.enum(["admin", "gestor", "consulta"], {
    errorMap: () => ({ message: "Selecione uma permissão" }),
  }),
});

export const resetPasswordSchema = z
  .object({
    password: z.string().min(6, "Senha deve ter ao menos 6 caracteres"),
    confirmPassword: z.string(),
  })
  .refine((d) => d.password === d.confirmPassword, {
    message: "As senhas não coincidem",
    path: ["confirmPassword"],
  });

export type SignInFormValues = z.infer<typeof signInSchema>;
export type SignUpFormValues = z.infer<typeof signUpSchema>;
